import React from 'react'
import { UsersConnectionsHome } from '../components/UsersConnections/UsersConnectionsHome'
import '../css/evidencias.css';

export const UsersConnectionsPage = () => {
    return (
        <UsersConnectionsHome />
    )
}